// extracted by mini-css-extract-plugin
module.exports = {"container":"OpenInPlayerBtn_container__dpNaY","icon":"OpenInPlayerBtn_icon__3t9pA"};